import { getNativeMessageHandler } from '../runtime/native-bridge.js'

export class BadgeService {
    #currentBadgeCount = 0

    public async setCount(count: number): Promise<number> {
        const nextCount = Math.max(0, Number(count) || 0)

        if (this.#hasNativeBadgeBridge()) {
            await this.#setNativeBadge(nextCount)
        } else {
            await this.#setWebBadge(nextCount)
        }

        this.#currentBadgeCount = nextCount
        return this.#currentBadgeCount
    }

    public async incrementCount(): Promise<number> {
        return await this.setCount(this.#currentBadgeCount + 1)
    }

    public async clearCount(): Promise<number> {
        if (this.#hasNativeBadgeBridge()) {
            await this.#clearNativeBadge()
        } else {
            await this.#clearWebBadge()
        }

        this.#currentBadgeCount = 0
        return this.#currentBadgeCount
    }

    public getCount(): number {
        return this.#currentBadgeCount
    }

    #hasNativeBadgeBridge(): boolean {
        return Boolean(getNativeMessageHandler('set-badge') && getNativeMessageHandler('clear-badge'))
    }

    async #setNativeBadge(count: number): Promise<void> {
        const handler = getNativeMessageHandler('set-badge')
        if (!handler) {
            throw new Error('Native badge bridge unavailable.')
        }

        handler.postMessage({ count })
    }

    async #clearNativeBadge(): Promise<void> {
        const handler = getNativeMessageHandler('clear-badge')
        if (!handler) {
            throw new Error('Native badge bridge unavailable.')
        }

        handler.postMessage(null)
    }

    async #setWebBadge(count: number): Promise<void> {
        if (!('setAppBadge' in navigator)) {
            throw new Error('Web Badging API unavailable.')
        }

        await navigator.setAppBadge(count)
    }

    async #clearWebBadge(): Promise<void> {
        if (!('clearAppBadge' in navigator)) {
            throw new Error('Web Badging API unavailable.')
        }

        await navigator.clearAppBadge()
    }
}
